import React, { useState, Fragment, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';

import { TextField, Button, Modal, Backdrop, Fade, Grid } from '@material-ui/core';

import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

import { useSnackbar } from 'notistack';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: 'none',
  },
  flex: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '1rem',
    alignItems: 'center',
  },
  button: {
    height: 'fit-content',
  },
  marginB: {
    marginBottom: '1rem',
  },
  marginR: {
    marginRight: '1rem',
  },
}));

export default function UpdateTaxModal(props) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [amount, setAmount] = useState();

  useEffect(() => {
    setName(props.data.name);
    setAmount(props.data.amount);
  }, [props]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    const token = Cookies.get('jwt');

    await axios
      .delete(`${process.env.REACT_APP_API}/taxes/${props.data._id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        setOpen(false);
        window.location.reload();
      })
      .catch((err) => {
        enqueueSnackbar('Une erreur est survenue', {
          variant: 'error',
        });
      });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const token = Cookies.get('jwt');
    const tax = {
      name,
      amount,
    };

    await axios
      .patch(`${process.env.REACT_APP_API}/taxes/${props.data._id}`, tax, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        setOpen(false);
        window.location.reload();
      })
      .catch((err) => {
        enqueueSnackbar('Une erreur est survenue', {
          variant: 'error',
        });
      });
  };

  return (
    <>
      <Button type="button" variant="contained" color="primary" onClick={handleOpen}>
        <EditIcon />
      </Button>
      <Modal
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div className={classes.flex}>
              <h2>Modification de la taxe</h2>
              <Button
                className={classes.button}
                type="button"
                variant="contained"
                color="secondary"
                onClick={handleDelete}
              >
                <DeleteIcon />
              </Button>
            </div>
            <form className={classes.form} onSubmit={handleUpdate}>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <TextField
                    className={classes.marginB}
                    id="name"
                    label="Nom"
                    type="text"
                    value={name}
                    variant="outlined"
                    onChange={(e) => setName(e.target.value)}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.marginB}
                    id="amount"
                    label="Taux"
                    type="string"
                    value={amount}
                    variant="outlined"
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </Grid>
              </Grid>

              <Button variant="contained" color="primary" type="submit" fullWidth>
                Modifier
              </Button>
            </form>
          </div>
        </Fade>
      </Modal>
    </>
  );
}
